import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

import AppShell from '@/components/AppShell';
import PrivateRoute from '@/components/PrivateRoute';

const LoginPage = lazy(() => import('@/pages/login'));
const FeishuCallbackPage = lazy(() => import('@/pages/feishu-callback'));
const HomePage = lazy(() => import('@/pages/home/page'));
const SamplesPage = lazy(() => import('@/pages/samples/page'));
const SampleDetailPage = lazy(() => import('@/pages/samples/detail'));
const LocationsPage = lazy(() => import('@/pages/locations/page'));
const DocumentsPage = lazy(() => import('@/pages/documents/page'));
const BorrowPage = lazy(() => import('@/pages/borrow/page'));
const AccountPage = lazy(() => import('@/pages/account/page'));
const InventoryInPage = lazy(() => import('@/pages/inventory-in/page'));
const InventoryOutPage = lazy(() => import('@/pages/inventory-out/page'));
const TransferRegisterPage = lazy(() => import('@/pages/transfer-register/page'));
const BorrowRegisterPage = lazy(() => import('@/pages/borrow-register/page'));
const ScrapRegisterPage = lazy(() => import('@/pages/scrap-register/page'));
const DestroyRegisterPage = lazy(() => import('@/pages/destroy-register/page'));
const LocationManagePage = lazy(() => import('@/pages/location-manage/page'));
const SampleDropdownManagePage = lazy(() => import('@/pages/sample-dropdown-manage/page'));
const UserManagePage = lazy(() => import('@/pages/user-manage/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/auth/feishu/callback',
    element: <FeishuCallbackPage />
  },
  {
    path: '/',
    element: <PrivateRoute><AppShell /></PrivateRoute>,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'samples', element: <SamplesPage /> },
      { path: 'samples/:id', element: <SampleDetailPage /> },
      { path: 'locations', element: <LocationsPage /> },
      { path: 'documents', element: <DocumentsPage /> },
      { path: 'documents/:documentType', element: <DocumentsPage /> },
      { path: 'borrow', element: <BorrowPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: 'inventory-in', element: <PrivateRoute warehouseOnly><InventoryInPage /></PrivateRoute> },
      { path: 'inventory-out', element: <PrivateRoute warehouseOnly><InventoryOutPage /></PrivateRoute> },
      { path: 'transfer-register', element: <PrivateRoute warehouseOnly><TransferRegisterPage /></PrivateRoute> },
      { path: 'borrow-register', element: <BorrowRegisterPage /> },
      { path: 'scrap-register', element: <PrivateRoute warehouseOnly><ScrapRegisterPage /></PrivateRoute> },
      { path: 'destroy-register', element: <PrivateRoute warehouseOnly><DestroyRegisterPage /></PrivateRoute> },
      { path: 'location-manage', element: <PrivateRoute warehouseOnly><LocationManagePage /></PrivateRoute> },
      { path: 'sample-dropdown-manage', element: <SampleDropdownManagePage /> },
      { path: 'user-manage', element: <UserManagePage /> },
      { path: 'photo-in', element: <Navigate to='/inventory-in' replace /> },
      { path: 'photo-out', element: <Navigate to='/inventory-out' replace /> },
      { path: 'photo-borrow', element: <Navigate to='/borrow-register' replace /> }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
